var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDoubleArrowLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49075 6.13296e-06C5.62603 -0.000691676 5.75587 0.0581841 5.85094 0.163336C6.04969 0.380727 6.04969 0.7329 5.85094 0.950291L1.22963 5.99868L5.85094 11.0471C6.04969 11.2645 6.04969 11.6166 5.85094 11.834C5.75628 11.9401 5.62639 12 5.49075 12C5.35511 12 5.22522 11.9401 5.13056 11.834L0.149064 6.39216C-0.0496883 6.17476 -0.0496883 5.82259 0.149064 5.6052L5.13056 0.163336C5.22562 0.0581841 5.35546 -0.000691676 5.49075 6.13296e-06Z",
    fill: "#139FC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4907 6.13296e-06C10.626 -0.000691676 10.7559 0.0581841 10.8509 0.163336C11.0497 0.380727 11.0497 0.7329 10.8509 0.950291L6.22963 5.99868L10.8509 11.0471C11.0497 11.2645 11.0497 11.6166 10.8509 11.834C10.7563 11.9401 10.6264 12 10.4907 12C10.3551 12 10.2252 11.9401 10.1306 11.834L5.14906 6.39216C4.95031 6.17476 4.95031 5.82259 5.14906 5.6052L10.1306 0.163336C10.2256 0.0581841 10.3555 -0.000691676 10.4907 6.13296e-06Z",
    fill: "#139FC8"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDoubleArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/double-arrow-left.e7f6353d123b73956dd8c515013f9d06.svg";